











import { Component, Vue, Prop } from 'vue-property-decorator'
import { Button } from '@alpha/ink'

@Component({
  components: {
    Button
  }
})
export default class CompletionCounter extends Vue {
  @Prop({ required: true }) readonly steps!: number
  @Prop({ required: true }) readonly completedSteps!: number

  get completed () {
    return this.completedSteps >= this.steps
  }
}
